import React, {useEffect} from 'react'
import { useUser } from '@/context/UserProvider'
import { PageWrapper } from './SignOutPage.styles'
import { OvalLoadingSpinner } from '@/components/__UI'

const SignOutPage = () => {
  const { logout } = useUser()

  useEffect(() => {
    logout()
  }, [logout])

  return (
    <PageWrapper>
      <OvalLoadingSpinner />
    </PageWrapper>
  )
}

export default SignOutPage
